import { BASE_API_URL } from "./Url-config";
import axios_instance from "./API_Interceptor";

// derive current home from the pathname (hooks can't be used at top-level)
const pathParts = (typeof window !== 'undefined' && window.location && window.location.pathname)
  ? window.location.pathname.split('/')
  : [];
const currentHome = pathParts[1] || 'default';

/***
   * This API Utility method is used to
   * fetch JWT access token from session storage 
   */
// const getAuthHeaders = () => {
//   const accessToken = sessionStorage.getItem('authToken');
//   return {
//     "Authorization": `Bearer ${accessToken}`,
//   }
// }

/**
 * Method is called while logging out
 * to clear details from session & local storage
 * 
 */
export async function logOut() {
  sessionStorage.clear();
  if (localStorage.getItem("activeTab")) {
    localStorage.removeItem("activeTab")
  }
}

/***
   * This API Utility variable is used to
   * send input paramaters for API
   */
export var apiInputRequest = {
  "endPoint": "",
  "data": "",
}

/***
   * This API Utility method is accepting GET request
   * with input parameter containing
   * endPoint (API Endpoint), params (string && formatted with /) 
   */
export function fetchAPIDataGET(input) {
  let response = axios_instance.get(BASE_API_URL + input.endPoint)
  let axiosPromise = response;
  response.then(res => {
    if (res === "Access denied" || res === "Invalid token") {
      logOut();
      window.location.href = `/${currentHome}/login`;
      return;
    }
  })
    .catch(err => {
      throw err;
    })
  return axiosPromise;
}

/***
   * This ASYNC API Utility method is accepting GET request
   * with input parameter containing
   * endPoint (API Endpoint), params (string && formatted with /) 
   */
export async function fetchAsyncAPIDataGET(input) {

  var response =  axios_instance.get(BASE_API_URL + input.endPoint)
  var axiosPromise = response;
  response.then(res => {
    if (res === "Access denied" || res === "Invalid token") {
      logOut();
      window.location.href = `/${currentHome}/login`;
      return;
    }
  })
    .catch(err => {
      throw err;
    })
  return axiosPromise;
}


/***
   * This API Utility method is accepting POST request
   * with input parameter containing
   * endPoint (API Endpoint), params (string && formatted with /), data (request body)
   */
export function sendAPIDataPOST(input) {
  var response = axios_instance.post(BASE_API_URL + input.endPoint, input.data)
  var axiosPromise = response;
  response.then(res => {
    if (res === "Access denied" || res === "Invalid token") {
      logOut();
      window.location.href = `/${currentHome}/login`;
      return;
    }
  })
    .catch(err => {
      throw err;
    })
  return axiosPromise;
}

export async function sendAsyncAPIDataPOST(input) {
  var response = axios_instance.post(BASE_API_URL + input.endPoint, input.data)
  var axiosPromise = response;
  response.then(res => {
    if (res === "Access denied" || res === "Invalid token") {
      logOut();
      window.location.href = `/${currentHome}/login`;
      return;
    }
  })
    .catch(err => {
      throw err;
    })
  return axiosPromise;
}

export function updateAPIDataPUT(input) {
  var response = axios_instance.put(BASE_API_URL + input.endPoint, input.data);
  var axiosPromise = response;
  response.then(res => {
    if (res === "Access denied" || res === "Invalid token") {
      logOut();
      window.location.href = `/${currentHome}/login`;
      return;
    }
  })
    .catch(err => {
      throw err;
    })
  return axiosPromise;
}

export async function updateAsyncAPIDataPUT(input) {
  var response = axios_instance.put(BASE_API_URL + input.endPoint, input.data);
  var axiosPromise = response;
  response.then(res => {
    if (res === "Access denied" || res === "Invalid token") {
      logOut();
      return window.location.href = `/${currentHome}/login`;
    }
  })
    .catch(err => {
      throw err;
    })
  return axiosPromise;
}

